import { IconButton } from '@sweep-io/sweep-design';
import { Close } from '@sweep-io/sweep-design/dist/icons';

const ClosePanelButton = ({ closePanel }: { closePanel?: () => void }) =>
  closePanel ? (
    <IconButton onClick={closePanel} variant="flat" size="small">
      <Close />
    </IconButton>
  ) : null;

export default ClosePanelButton;
